export default {
    data() {
        return {
            pagination: {
                current_page: 1,
                per_page: 15,
            },
            //this should be overridden by the component extending this mixin
            dataKey: "items.data",
        };
    },
    computed: {
        pageCount() {
            return Math.ceil(
                _.get(this, this.dataKey).length / this.pagination.per_page
            );
        },

        paginatedData() {
            let page_number = this.pagination.current_page - 1;
            return _.get(this, this.dataKey).slice(
                page_number * this.pagination.per_page,
                (page_number + 1) * this.pagination.per_page
            );
        },

        dataCount() {
            return _.get(this, this.dataKey).length;
        },
    },
    methods: {
        changePage(page) {
            this.pagination.current_page = page;
        },

        handleSizeChange(val) {
            this.pagination.per_page = val;
        },
    },
};
